import React from "react";
import {
  Container,
  Title,
  Header,
  HeaderTitle,
  HeaderIconLeft,
  HeaderIconRight,
  TableContainer,
  TableHeader,
  TableBody,
} from "../Component/TableComponent/Table";
import InputSearch from "../Component/Search/Search";
import PickColumn from "../Component/PickColumn/PickColumn";
import Filter from "../Component/Filter/Filter";
import AddGroup from "../Component/AddGroup/AddGroup";
import CreatedOn from "../Component/CreatedOn/CreatedOn";
import { buyers } from "../Component/Utils/Utils";

function All_Buyer_Edit() {
  const RowHeader = [
    "ID",
    "Status",
    "Company Name",
    "Email",
    "Assignes",
    "Phone Number",
    "Location",
    "Tags",
    "Actions",
  ];
  const path ="/admin-dashboard/save-product"
  return (
    <>
      <Container>
        <Title  showImport={false}>
          All Buyer
        </Title>
        <Header>
          <HeaderTitle>
            <HeaderIconLeft>
              <InputSearch />
              <PickColumn />
            </HeaderIconLeft>
            <HeaderIconRight>
              <Filter />
              <AddGroup />
              <CreatedOn />
            </HeaderIconRight>
          </HeaderTitle>
          <TableContainer>
            <TableHeader children={RowHeader} />
            <TableBody
              rows={buyers}
              // isLoading={isLoading}
              // error={error}\
              path={path}
            />
          </TableContainer>
        </Header>
      </Container>
    </>
  );
}

export default All_Buyer_Edit;
